import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@app/auth/auth.service';
import { PUBLIC_ROUTES } from '../constants/app.constants';
import { UserRole } from '../constants/roles.enum';

export const SubscriptionGuard: CanActivateFn = () => {
    const auth = inject(AuthService);
    const router = inject(Router);

    // Si no está logueado o token caducado -> redirigir a login
    if (!auth.isUserLoggedIn()) {
        return router.createUrlTree([`/${PUBLIC_ROUTES.login}`]);
    }

    const token = auth.getDecodedToken();

    // Si tiene rol VISITOR --> permitir acceso
    if (token.role === UserRole.VISITOR) {
        return true;
    } else {
        // cualquier otro rol --> redirigir a calendario
        return router.createUrlTree([auth.homeRoute()]);
    }

};
